import Config from '@/config';

export function buildUrl(uri: string) {
  return `${Config.getValue('websiteUrl')}${uri.startsWith('/') ? uri : `/${uri}`}`;
}
